import { create } from "zustand"
import { api } from "@/lib/api-client"

interface User {
  id: string
  email: string
  first_name: string
  last_name: string
  role: string
  avatar_url: string | null
  tenant_id: string
}

interface AuthState {
  user: User | null
  isAuthenticated: boolean
  isLoading: boolean
  login: (email: string, password: string, remember_me?: boolean) => Promise<{ mfa_required?: boolean; user_id?: string }>
  register: (data: {
    email: string
    password: string
    first_name: string
    last_name: string
    company_name: string
  }) => Promise<void>
  logout: () => Promise<void>
  checkSession: () => Promise<void>
  setUser: (user: User | null) => void
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isAuthenticated: false,
  isLoading: true,

  login: async (email, password, remember_me = false) => {
    const response = await api.post<{ user?: User; mfa_required?: boolean; user_id?: string }>(
      "/api/v1/auth/login",
      { email, password, remember_me }
    )
    if (response.user) {
      set({ user: response.user, isAuthenticated: true })
    }
    return { mfa_required: response.mfa_required, user_id: response.user_id }
  },

  register: async (data) => {
    const response = await api.post<{ user: User }>("/api/v1/auth/register", data)
    set({ user: response.user, isAuthenticated: true })
  },

  logout: async () => {
    await api.post("/api/v1/auth/logout")
    set({ user: null, isAuthenticated: false })
  },

  checkSession: async () => {
    try {
      const response = await api.get<{ user: User }>("/api/v1/auth/me")
      set({ user: response.user, isAuthenticated: true, isLoading: false })
    } catch {
      set({ user: null, isAuthenticated: false, isLoading: false })
    }
  },

  setUser: (user) => set({ user, isAuthenticated: !!user }),
}))
